module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/product-images/product-03-82d777bf0bd6e1c7a952ea62e3106745.jpg";